module.exports = __webpack_public_path__ + "media/images/apple_health/watch/cyclebar-037794548e70876d2751006ff28b5b32.svg";